import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PatientCaseViewDataModel} from '../models/patient/patient-case-view-data.model';
import {CreatePatientCaseModel} from '../models/caseProcedures/create-patient-case.model';
import {Globals} from '../globals';
import {PatientCaseDataModel} from '../models/patient/patient-case-data.model';
import {Observable} from "rxjs";
import { CaseForTooth } from '../modules/ar/_models/ar.models';

@Injectable({
  providedIn: 'root'
})
export class CaseService {

  constructor(private http: HttpClient, private globals: Globals) { }

  deleteCase(PatientCaseId: string) {
    return this.http.get<void>(`api/patient-cases/delete-case/${PatientCaseId}`);
  }

  saveCase(model: PatientCaseViewDataModel) {
    return this.http.post<void>(`api/patient-cases/create-case`, model.Case);
  }

  saveCaseforTooth(model: CaseForTooth) {
    return this.http.post<void>(`api/patient-cases/create-case-for-tooth`, model);
  }

  getPatientCaseById(PatientCaseId: string): Observable<PatientCaseDataModel>{
    return this.http.get<PatientCaseDataModel>(`api/patient-cases/getPatientCaseById/${PatientCaseId}`);
  }

  updateCaseStatus(PatientCaseId: string, ValidValueItemId: string) {
    return this.http.get<PatientCaseDataModel>(`api/patient-cases/update-case-status/${PatientCaseId}/${ValidValueItemId}`);
  }

  getPatientCaseStatus4Landing(PatientCaseId: string) {
    return this.http.get<string>(`/api/patient-cases/getPatientCaseStatus4Landing/${PatientCaseId}`);
  }
}
